/**
 * KAN-880: таблица лидов CRM страницами (GET /api/v1/crm/leads/?offset=&limit=).
 * "Показать ещё" грузит offset=next_offset и дописывает строки. Ключ под
 * CRM_LEADS_QUERY_KEY (вложен в ATTENTION_QUERY_KEY): действия строк и правки
 * обновляют таблицу вместе с доской и блоком внимания.
 */
import { useInfiniteQuery } from '@tanstack/react-query';
import { crmApi } from '@/services/api/crm';
import { CRM_LEADS_QUERY_KEY } from '@/services/api/queryKeys';
import { CRM_LEADS_PAGE_SIZE, type CrmLeadsQuery } from '@/lib/crmLeads';

export const crmLeadsKey = (query: CrmLeadsQuery) => [...CRM_LEADS_QUERY_KEY, query] as const;

export function useCrmLeads(query: CrmLeadsQuery) {
  return useInfiniteQuery({
    queryKey: crmLeadsKey(query),
    queryFn: ({ pageParam }) => crmApi.getLeads({ ...query, offset: pageParam, limit: CRM_LEADS_PAGE_SIZE }),
    initialPageParam: 0,
    getNextPageParam: (last) => last.next_offset ?? undefined,
    retry: false,
  });
}
